import type { SxProps, Theme } from '@mui/material/styles';

import { HcoCard } from '@/components/Hco/HcoCard/HcoCard';
import { HcpCard, CardView } from '@/components/Hcp/HcpCard/HcpCard';
import { Hcphco } from '@/core/graphql/generated/types';
import { isOfTypeHco } from '@/utils/hco/isOfTypeHco';
import { isOfTypeHcp } from '@/utils/hcp/isOfTypeHcp';

import { getProfileCardSx } from './ProfileCard.styles';

type Props = {
	profile: Hcphco;
	view?: CardView;
	withIcon?: boolean;
	withFullAddress?: boolean;
	wrapChips?: boolean;
	query?: string;
	customSx?: {
		root?: SxProps<Theme>;
		content?: SxProps<Theme>;
		name?: SxProps<Theme>;
	};
};

export const ProfileCard = ({
	profile,
	view,
	withIcon = true,
	withFullAddress,
	wrapChips,
	query,
	customSx
}: Props) => {
	const sx = getProfileCardSx(view, customSx);

	if (isOfTypeHcp(profile)) {
		return (
			<HcpCard
				hcp={profile}
				withIcon={withIcon}
				withFullAddress={withFullAddress}
				view={view}
				wrapChips={wrapChips}
				query={query}
				disableLink
				affiliationType='link'
				customSx={sx}
			/>
		);
	}

	if (isOfTypeHco(profile)) {
		return (
			<HcoCard
				hco={profile}
				withIcon={withIcon}
				withFullAddress={withFullAddress}
				view={view}
				wrapChips={wrapChips}
				query={query}
				disableLink
				customSx={sx}
			/>
		);
	}

	return null;
};
